import React from 'react'
import { Route as ZionRoute } from '@fs/zion-router'
import ActivityCover, { hasActivityCover } from './ActivityCover'

/**
 * Drop-in replacement for zion-router's Route. Removes full-screen spinner that shows while waiting for Zion's
 * personal-data check to resolve. Only changes the TWA experience; all of web is untouched.
 */
export default function QuietRoute(props) {
  if (!hasActivityCover()) {
    return <ZionRoute {...props} />
  }

  return <ZionRoute LoadingComponent={ActivityCover} {...props} />
}
